import React, { useState } from "react";
import { MoreHorizontal, CheckCircle } from "lucide-react";
import styles from "../../styles/automation-styles";
import moment from "moment";

// AutomationCard Component

// AutomationCard Component
const AutomationCard = ({
  automation,
  onMenuOpen,
  updateActiveAsync,
  getItemForUpdateAsync,
}) => {
  const [checked, setChecked] = useState(automation.active);
  const handleSwitchChange = () => {
    updateActiveAsync(automation.id, !checked);
    setChecked(!checked);
  };

  const editItem = () => {
    getItemForUpdateAsync(automation.id);
  };

  return (
    <div style={styles.card}>
      <div style={styles.cardContent}>
        <div style={styles.cardHeader}>
          <div>
            <h3 style={styles.cardTitle} onClick={editItem}>
              {automation.id}. {automation.name}
            </h3>
            <p style={styles.cardCondition}>{automation.description}</p>
          </div>
          <div style={styles.cardActions}>
            {/* Custom Switch Toggle */}
            <div
              style={{
                ...styles.switchContainer,
                ...(checked ? styles.switchActive : styles.switchInactive),
              }}
              onClick={handleSwitchChange}
            >
              <div
                style={{
                  ...styles.switchKnob,
                  ...(checked ? styles.switchKnobActive : {}),
                }}
              >
                {checked && (
                  <CheckCircle
                    size={12}
                    color="#48bb78"
                    style={styles.switchIcon}
                  />
                )}
              </div>
            </div>
            <button
              style={styles.menuButton}
              onClick={(e) => onMenuOpen(e, automation)}
            >
              <MoreHorizontal size={20} />
            </button>
          </div>
        </div>
      </div>
      <div style={styles.cardDivider}></div>
      <div style={styles.cardFooter}>
        <span>
          Última modificação:{" "}
          {console.log("automation.updatedat", automation)}
          {moment(automation.updatedat == undefined ? automation.createdat : automation.updatedat).format(
            "DD/MM/YYYY HH:mm:ss"
          )}
        </span>
        <span>Por: {automation.username}</span>
        {/*<span>Tickets afetados (últimos 7 dias): {automation.affectedTickets}</span>*/}
      </div>
    </div>
  );
};

export default AutomationCard;
